import { modelHelperModule } from './model-helper';

export const externalRevisionModelModule = angular
  .module('Q.models.externalRevision', [modelHelperModule])

  .factory('ExternalRevision', function (ModelHelper, $rootScope) {
    let ExternalRevision = ModelHelper.defineResource({
      name: 'ExternalRevision',
      endpoint: 'external_revisions',
      methods: {},
      staticMethods: {
        loadFor(reviseable) {
          if ($rootScope.playbackToken) {
            ExternalRevision.endpoint = `external_revisions/share_revisions/${reviseable.id}`;
          }
          return ExternalRevision.retrieveAll(
            { referenceId: reviseable.id, per: 250 },
            { cacheResponse: false, bypassCache: true },
          ).then((revisions) => (reviseable.revisions = revisions));
        },
      },
    });

    return ExternalRevision;
  });
